<template>
    <div id="app" class="relative" ref="app">
        <nav-bar ref="header" :nav-bar-fixed="navBarFixed"/>
        <router-view ref="index"/>
        <footer-view :class="{'footer-wrapper': is_position}" ref="footer"/>
    </div>
</template>

<script>
    import NavBar from './layout/navbar/main'
    import FooterView from './layout/footerView/main'
    export default {

        components: {
            NavBar,
            FooterView
        },

        data() {
            return {
                navBarFixed: false,
                is_position: false,
                timer: '',
                keyWords: '',
                title: ''
            }
        },

        // metaInfo() {
        //     // title: 'keyword',
        //     return {
        //         title: this.title,
        //         meta: [
        //             {
        //                 name: 'keywords',
        //                 content: this.keyWords
        //             }
        //         ]
        //     }
        // },

        // beforeDestroy() {
        //     if(this.timer) {
        //         clearInterval(this.timer)
        //     }
        // },
        //
        // mounted() {
        //     this.timer = setInterval(() => {
        //         this.watchHeight();
        //     },300);
        //     this.getKeyWords();
        // },

        methods: {
            watchHeight() {
                let allHeight = this.$refs.app.clientHeight;
                let headHeight = this.$refs.header.$el.offsetHeight;
                let footHeight = this.$refs.footer.$el.offsetHeight;
                let indexHeight = this.$refs.index.$el.offsetHeight;
                let height = allHeight - headHeight - footHeight;
                this.is_position = indexHeight < height;
                // console.log(this.$refs.index.$el.offsetHeight);
            },

            // getKeyWords(){
            //     this.$post(
            //         'api.php/Index/homeKeywords',
            //     ).then(res => {
            //         if(res.status === 1) {
            //             this.title = res.data.site_name;
            //             this.keyWords = res.data.intro + ',' + res.data.site_keywords;
            //         }
            //     })
            // }
        }
    }

</script>

<style>
#app {
    width: 100%;
    height: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #333333;
}

/*.footer-wrapper {*/
/*    position: fixed;*/
/*    bottom: 0;*/
/*    left: 0;*/
/*}*/

.el-pagination {text-align: center}

.footer-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
}

.pagination-box {
    width: 100%;
    height: 32px;
}

.el-pagination {
    width: 500px;
    margin: 0 auto;
}
</style>
